// extracted by mini-css-extract-plugin
module.exports = {"input":"FieldCurrencyInput_input__3SWtN","inputSuccess":"FieldCurrencyInput_inputSuccess__rqX09","inputError":"FieldCurrencyInput_inputError__3NceZ"};